export const findNestedNode = (nodes, key, nodeCode) => {
  // Creamos una pila para almacenar los elementos que deben ser examinados
  const stack = [...nodes];

  // Recorremos la pila hasta que esté vacía
  while (stack.length > 0) {
    // Tomamos el elemento actual de la pila
    const currentElement = stack.pop();

    // Verificamos si el elemento no es nulo y de tipo objeto
    if (currentElement !== null && typeof currentElement === 'object') {
      // Si el objeto tiene el code buscado, lo devolvemos
      if (currentElement[key] === nodeCode) {
        return currentElement;
      }
      // Si el elemento actual tiene childs, agregamos sus childs
      // a la pila para volver a llamar el método recursivamente
      if (Array.isArray(currentElement?.childs)) {
        stack.push(...currentElement?.childs);
      }
    }
  }

  // Si no encontramos el objeto con el valor buscado, devolvemos null
  return null;
};
